class TC_TimetableCache {
    constructor (cachedData) {
        this.cachedData = cachedData;
        this.cacheTTL = 10 * 60 * 1000; // 10 mins
    }

    getTimetable (streamID, expirationCheck = true) {
        let currentTime = +new Date();

        if (expirationCheck) {
            if (this.cachedData[streamID] && this.cachedData[streamID].expirationDate > currentTime) {
                return this.cachedData[streamID].timetable;
            }
        } else if (!expirationCheck && this.cachedData[streamID]) {
            return this.cachedData[streamID].timetable;
        }

        return false;
    }

    saveTimetable (streamID, dataToSave) {
        let currentTime = +new Date();

        this.cachedData[streamID] = {
            timetable: dataToSave,
            expirationDate: currentTime + this.cacheTTL
        };
    }
}